import { render, staticRenderFns } from "./EditMetaDataComponent.vue?vue&type=template&id=17311bf6&"
import script from "./EditMetaDataComponent.vue?vue&type=script&lang=js&"
export * from "./EditMetaDataComponent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports